
import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Mic,
  MicOff,
  Video,
  VideoOff,
  Share2,
  MessageSquare,
  Users,
  ScreenShare,
  MessageCircle,
  Youtube,
  Settings
} from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface EventControlsProps {
  isHost: boolean;
  isRecording: boolean;
  isLiveStreaming: boolean;
  onToggleRecording: () => void;
  onToggleLiveStreaming: (platform?: string) => void;
}

const EventControls: React.FC<EventControlsProps> = ({
  isHost,
  isRecording,
  isLiveStreaming,
  onToggleRecording,
  onToggleLiveStreaming
}) => {
  const [audioEnabled, setAudioEnabled] = useState(true);
  const [videoEnabled, setVideoEnabled] = useState(true);
  const [screenSharing, setScreenSharing] = useState(false);
  
  const toggleAudio = () => {
    setAudioEnabled(!audioEnabled);
  };
  
  const toggleVideo = () => {
    setVideoEnabled(!videoEnabled);
  };
  
  const toggleScreenShare = () => {
    setScreenSharing(!screenSharing);
  };
  
  return (
    <div className="flex items-center justify-center space-x-2 md:space-x-4">
      <Button
        variant="outline"
        size="sm"
        className={`rounded-full p-2 ${!audioEnabled ? 'bg-red-100 text-red-700 border-red-200' : ''}`}
        onClick={toggleAudio}
      >
        {audioEnabled ? <Mic className="h-5 w-5" /> : <MicOff className="h-5 w-5" />}
      </Button>
      
      <Button
        variant="outline"
        size="sm"
        className={`rounded-full p-2 ${!videoEnabled ? 'bg-red-100 text-red-700 border-red-200' : ''}`}
        onClick={toggleVideo}
      >
        {videoEnabled ? <Video className="h-5 w-5" /> : <VideoOff className="h-5 w-5" />}
      </Button>
      
      <Button
        variant="outline"
        size="sm"
        className={`rounded-full p-2 ${screenSharing ? 'bg-green-100 text-green-700 border-green-200' : ''}`}
        onClick={toggleScreenShare}
      >
        <ScreenShare className="h-5 w-5" />
      </Button>
      
      {isHost && (
        <Button
          variant="outline"
          size="sm"
          className={`rounded-full p-2 ${isRecording ? 'bg-red-100 text-red-700 border-red-200' : ''}`}
          onClick={onToggleRecording}
        >
          <MessageCircle className="h-5 w-5" />
        </Button>
      )}
      
      {isHost && (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="outline"
              size="sm"
              className={`rounded-full p-2 ${isLiveStreaming ? 'bg-green-100 text-green-700 border-green-200' : ''}`}
            >
              <Share2 className="h-5 w-5" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            <DropdownMenuItem onClick={() => onToggleLiveStreaming("public")}>
              <Users className="h-4 w-4 mr-2" />
              <span>{isLiveStreaming ? "End public stream" : "Stream to public page"}</span>
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => onToggleLiveStreaming("youtube")}>
              <Youtube className="h-4 w-4 mr-2" />
              <span>{isLiveStreaming ? "End YouTube stream" : "Stream to YouTube"}</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      )}
      
      <Button
        variant="outline"
        size="sm"
        className="rounded-full p-2"
      >
        <MessageSquare className="h-5 w-5" />
      </Button>
      
      {isHost && (
        <Button
          variant="outline"
          size="sm"
          className="rounded-full p-2"
        >
          <Settings className="h-5 w-5" />
        </Button>
      )}
    </div>
  );
};

export default EventControls;
